export default "__VITE_ASSET__ov91uYQ8__"